import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'initial_refresher_train_on_responsibilities_members_fire_brigade'

export const dataPointDefinition = {
  retracedId: 'initial_refresher_train_on_responsibilities_members_fire_brigade',
  name: 'Initial and refresher trainings on responsibilities of members of the Fire Brigade/Emergency Response Team are not in pl',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-eme-47x',
      number: 'HS-EME-22-1',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-eme-46',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-eme-11,Yes',
      machineShowHide: '[2],hs-eme-11,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-47x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30910,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
